import { TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Alert, AlertDescription, AlertTitle } from '@/Domain/components/Shared/Alert/Alert';

export const FailedPaymentAlert = () => {
  const { t } = useTranslation('subscription_page');

  return (
    <Alert variant="destructive">
      <AlertTitle>
        <TriangleAlert className="size-4" />
        {t('failed_payment_alert.title')}
      </AlertTitle>
      <AlertDescription>{t('failed_payment_alert.description')}</AlertDescription>
    </Alert>
  );
};
